module.exports = __webpack_public_path__ + "static/media/diktat-7.3c667a51.mp3";